import AffiliateLink from '@/components/pages/affiliate/link/AffiliateLink.vue'
import AffiliateRevenue from '@/components/pages/affiliate/revenue/AffiliateRevenue.vue'

export default [
  {
    path: 'affiliate/link',
    name: 'affiliate.link',
    meta: { access: { menu: 'affiliate', subMenu: 'affiliate-link-mgmt' } },
    component: AffiliateLink
  },
  {
    path: 'affiliate/revenue',
    name: 'affiliate.revenue',
    meta: { access: { menu: 'affiliate', subMenu: 'affiliate-link-mgmt' } },
    component: AffiliateRevenue
  }
]